module.exports = __webpack_public_path__ + "img/icon_consent.3f1ad685.svg";